
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-luggage-to-storage-facility",
      function () {
        return require("private-next-pages/ship-luggage-to-storage-facility/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-luggage-to-storage-facility"])
      });
    }
  